import * as React from 'react';
import { ReportUserView } from 'cb-model';
import {
  PageTitle,
  PaginatorAndListSettings,
  Search,
  Section,
  useCacheQuery,
  useCloneEntity,
  useQueryOptionsFromSearchParams,
} from 'gossamer-front-end';
import { ReportMenu } from './ReportMenu';
import { Filter } from 'gossamer-unified';
import { useSetMaxWeekCommencing } from './useSetMaxWeekCommencing';

export const UserWeekSearch = (): React.JSX.Element => {
  const [queryOptions, setQueryOptions] = useQueryOptionsFromSearchParams(ReportUserView);
  useSetMaxWeekCommencing(queryOptions, setQueryOptions);
  const LocalReportUserView = useCloneEntity(ReportUserView, (clone) => {
    clone.fields.user_id.listColumn = true;
  });
  const gCacheQueryItem = useCacheQuery(ReportUserView, queryOptions);
  LocalReportUserView.fields.institution_id.listColumn = !queryOptions?.where?.and?.find(
    (filt: Filter) => filt.fieldId === 'institution_id' && !!filt.value,
  );
  LocalReportUserView.fields.week_commencing.listColumn = !queryOptions?.where?.and?.find(
    (filt: Filter) => filt.fieldId === 'week_commencing' && !!filt.value,
  );

  return (
    <>
      <PageTitle title="User / Week Report" />
      <ReportMenu />
      <Section>
        <p>Bookings and Attendance per User per Week</p>
        <PaginatorAndListSettings
          entity={LocalReportUserView}
          gCacheQuery={gCacheQueryItem}
          queryOptions={queryOptions}
          render={Search}
          setQueryOptions={setQueryOptions}
        />
      </Section>
    </>
  );
};
